<template>
  <div class="medialib">
    <div id="vdoplayer" v-if="isvdo">
      <i @click="closePlay" class="el-icon-close"></i>
      <video :src="playurl" autoplay controls></video>
    </div>
    <div id="docs">
      <div id="newsfr" v-if="mtype=='news'">
        <h4>
          <h5 v-for="item,index in newsdata" :key="item.title+index">
            <img :src="require('../../public/newspic/'+item.picpost)" />
            <h3>
              <label>{{item.title}}</label>
              <label>{{item.desc}}</label>
              <el-row>
                <el-col :span="12">
                  <label @click="viewArticle(index)">View Article</label>
                </el-col>
                <el-col :span="12">
                  <img :src="require('@/assets/pic/media/time.png')"/><label>{{item.date}}</label>
                </el-col>
              </el-row>
            </h3>
          </h5>
        </h4>
      </div>
      <div id="productfr" v-if="mtype=='product'">
        <h5>
          <div @click="rowClick(1,item.url)" v-for="item in ctdata" :key="item.label" >
            <img :src="require('@/assets/pic/playbtn.png')" />
            <img :src="item.pic" />
            <label>{{item.label}}</label>
          </div>
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    data: Object
  },
  watch: {
    data (n) {
      this.menuSelect(n.type)
    },
    "$route": {
      handler (n) {
        this.menuSelect(n.query.sstype)
      }
    }
  },
  computed: {
    newsdata () {
      return require('../../public/news.json').data
    }
  },
  data () {
    return {
      isvdo: false,
      playurl: '',
      ctdata: [],
      mtype: ''
    }
  },
  methods: {
    viewArticle (index) {
      this.$router.push({path: '/newsdetail?index='+index})
      this.backToTop()
    },
    backToTop () {
      window.scrollTo(0,0)
    },
    rowClick (isplay, url) {
      this.backToTop()
      if (isplay) {
        this.playurl = url
        this.isvdo = true
      } else {
        window.open(url,'_blank')
      }
    },
    closePlay () {
      this.isvdo = false
      this.playurl = ''
    },
    menuSelect (type) {
      this.mtype = type
      this.ctdata = this.data.data
    }
  },
  mounted () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.medialib {
  background: #F7F8F8;
}

#docs {
  text-align: center;
}
#newsfr {
  background: white;
  padding-top: .53rem;
  padding-bottom: 2.11rem;
}
#newsfr h4 {
  margin: 0 auto 0 auto;
  width: 12.52rem;
  text-align: left;
}
#newsfr h5 {
  display: inline-block;
  width: 5.8rem;
  height: 4.85rem;
  margin: 0 .23rem .41rem .23rem;
  box-sizing: border-box;
  overflow: hidden;
  background: #F7F7F7;
}
#newsfr h3{
  box-sizing: border-box;
  padding-top: .05rem;
  margin: .25rem .19rem .19rem .19rem;
  height: calc(100% - 2.88rem);
  background: white;
}
#newsfr h3 label:nth-child(1) {
  font-size: .16rem;
  font-weight: bold;
  color: #4D4D4D;
  line-height: .24rem;
  display: block;
  margin: .18rem .15rem .16rem .15rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
#newsfr h3 label:nth-child(2) {
  font-size: .12rem;
  font-weight: bold;
  color: #CCCCCC;
  width: 4.8rem;
  height: .52rem;
  /* border: 1px solid red; */
  display: block;
  margin-left: .15rem;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: normal;
  /* white-space: nowrap */
}
#newsfr .el-row {
  margin-top: .2rem;
  /* border: 1px solid red; */
}
#newsfr .el-col:nth-child(1) label {
  width: 1.24rem;
  height: .42rem;
  border: .02rem solid #E0E0E0;
  border-radius: .2rem;
  display: inline-block;
  text-align: center;
  line-height: .42rem;
  font-size: .14rem;
  font-weight: 800;
  color: #333333;
  cursor: pointer;
  margin: 0 0 0 .15rem;
}
#newsfr .el-col:nth-child(2) {
  text-align: right;
  padding-right: .4rem;
  vertical-align: middle;
  padding-top: .1rem;
}
#newsfr .el-col:nth-child(2) label {
  width: 1rem;
  display: inline;
  vertical-align: middle;
  height: .18rem !important;
}
#newsfr .el-col:nth-child(2) img {
  width: .18rem;
  height: .18rem;
  vertical-align: middle;
  display: inline-block;
}
#newsfr img {
  width: .18rem;
  height: .18rem;
}
#newsfr img:nth-child(1) {
  width: 100%;
  height: 2.44rem;
  margin: 0;
  display: block;
}
#newsfr label {
  /* display: block; */
}

#productfr {
  padding-top: .53rem;
  padding-bottom: 2.11rem;
  background: none;
}
#productfr h5 {
  margin: 0 auto;
  width: 12.48rem;
  text-align: left;
}
#productfr div {
  width: 3.96rem;
  height: 2.9rem;
  cursor: pointer;
  display: inline-block;
  margin: 0 .1rem .33rem .1rem;
}
#productfr div:hover label{
  background: #EF8200;
  color: white;
}
#productfr img:nth-child(1) {
  position: absolute;
  width: .52rem;
  height: .41rem;
  margin: .91rem 0 0 1.72rem;
}
#productfr img:nth-child(2) {
  width: 100%;
  height: 2.22rem;
  margin: 0;
}
#productfr label {
  margin-top: -.05rem;
  display: block;
  height: .68rem;
  line-height: .68rem;
  background: white;
  font-size: .28rem;
  font-weight: 500;
  color: #4E4E4E;
  text-align: center;
}



</style>
